// import "./ProgressBar.scss";

// const ProgressBar = ({ title, resStr }: any) => {

//     const extractProgress = (resStr: any) => {
//         console.log(resStr)
//         if (resStr) {
//             const match = resStr.match(/\d+/);
//             console.log(resStr)
//             return match ? parseInt(match[0], 10) : 0;
//         } else {
//             return 0;
//         }
//     };

//     return (
//         <div key={resStr} className="progress-container">
//             <p className="progress-text">{title}</p>
//             <div className="progress-bar">
//                 <div className="progress-fill" style={{ width: `${extractProgress(resStr)}%` }}></div>
//             </div>
//             <span className="progress-percentage">{extractProgress(resStr)}%</span>
//         </div>
//     );
// };

// export default ProgressBar;

import { useState, useEffect } from "react";
import "./ProgressBar.scss";
import { useSelector } from "react-redux";
import { RootState } from "../../setup";

const ProgressBar = ({ title }: any) => {
    const [progress, setProgress] = useState<number>(0);
    const commandStatus: any = useSelector((state: RootState) => state.webSocket.commandStatus)

    useEffect(() => {
        if (commandStatus && commandStatus.ResStr) {
            setProgress(extractProgress(commandStatus.ResStr));
        }
    }, [commandStatus]);

    const extractProgress = (resStr: any) => {
        if (resStr) {
            const match = resStr.match(/\d+/);
            const value = match ? parseInt(match[0], 10) : 0;
            return Number.isNaN(value) ? 0 : value;
        }
        return 0;
    };

    return (
        <div key={commandStatus} className="progress-container">
            <p className="progress-text">{title}</p>
            <div className="progress-bar">
                <div className="progress-fill" style={{ width: `${progress}%` }}></div>
            </div>
            <span className="progress-percentage">{progress}%</span>
        </div>
    );
};

export default ProgressBar;
